var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8164 10.38H12.1837V13.71H17.2348C17.1429 14.52 16.5919 15.78 15.398 16.59C14.6633 17.13 13.5613 17.49 12.1837 17.49C9.79593 17.49 7.68369 15.96 6.94899 13.71C6.76532 13.17 6.67348 12.54 6.67348 11.91C6.67348 11.28 6.76532 10.65 6.94899 10.11C7.04083 9.93 7.04083 9.75 7.13266 9.66C7.9592 7.77 9.88777 6.42 12.1837 6.42C13.9286 6.42 15.0307 7.14 15.7654 7.77L18.3368 5.25C16.7755 3.9 14.6633 3 12.1837 3C8.60205 3 5.4796 4.98 4.01021 7.95C3.36735 9.21 3 10.56 3 12C3 13.44 3.36735 14.79 4.01021 16.05C5.4796 19.02 8.60205 21 12.1837 21C14.6633 21 16.7755 20.19 18.2449 18.84C19.9898 17.31 21 14.97 21 12.18C21 11.46 20.9083 10.92 20.8164 10.38Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.ab5804b3be367d9a69bb00048d6f6e4b.svg";
export { ForwardRef as ReactComponent };